import React, { useState } from "react";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { RouteComponentProps } from "react-router";
import { Theme, withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import AlertDialog from "../../common/AlertDialog";
import UiButton from "../../common/UiButton";
import UiArrowIcon from "../../common/UiArrowIcon";
import UserType from "../../../types/User";
import ProjectType from "../../../types/Project";
import withContext from "../../../tools/withContext";
import { tableRowActionButtonModernStyle } from "../../common/tableTheme";

const styles = (theme: Theme) =>
  createStyles({
    actionButtonModern: tableRowActionButtonModernStyle(theme),
  });

const options = [
  {
    label: "Modifier",
    roles: ["ROLE_ADMIN"],
  },
  {
    label: "Réinitialiser le token 2FA",
    roles: ["ROLE_ADMIN", "ROLE_PROJECT_ADMIN"],
  },
  {
    label: "Supprimer",
    roles: ["ROLE_ADMIN"],
  },
];

interface PropsType extends RouteComponentProps<any>, React.Props<any> {
  saveUser: Function;
  deleteUser: Function;
  resetToken2FA: Function;
  openDialog: Function;
  closeDialog: Function;
  onButtonClicked?: Function;
  user: UserType;
  projects: ProjectType[];
  classes: any;
  variant?: "default" | "modern";
  ctx: {
    user: {
      authorities: string[];
    };
  };
}

const UserActionButton = (props: PropsType) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertReset2FATokenOpen, setAlertReset2FATokenOpen] = useState(false);

  const {
    user,
    deleteUser,
    resetToken2FA,
    openDialog,
    onButtonClicked,
    classes,
    variant = "default",
    ctx: {
      user: {
        authorities: [userRole],
      },
    },
  } = props;
  const isModern = variant === "modern";

  const onMenuClick = (event: any, index: any) => {
    if (index === 0) {
      openDialog();
    } else if (index === 1) {
      openAlertReset2FA();
    } else if (index === 2) {
      openAlert();
    }
    closeMenu();
  };

  const actionButtonClicked = (e: any) => {
    setAnchorEl(e.currentTarget);
    if (onButtonClicked) {
      onButtonClicked(e);
    }
  };

  const closeMenu = () => setAnchorEl(null);

  const openAlert = () => setAlertOpen(true);

  const closeAlert = () => setAlertOpen(false);

  const openAlertReset2FA = () => setAlertReset2FATokenOpen(true);

  const closeAlertReset2FA = () => setAlertReset2FATokenOpen(false);

  const handleDelete = () => {
    deleteUser(user).then(() => closeAlert());
  };

  const handleReset2FA = () => {
    resetToken2FA(user).then(() => closeAlertReset2FA());
  };

  return (
    <React.Fragment>
      {alertOpen && (
        <AlertDialog
          title="Supprimer un utilisateur"
          text={`Voulez-vous vraiment supprimer l'utilisateur ${user.firstName} ${user.lastName}?`}
          open={alertOpen}
          onClose={closeAlert}
          onAccept={handleDelete}
        />
      )}
      {alertReset2FATokenOpen && (
        <AlertDialog
          title="Réinitialiser le token 2FA"
          text={`Voulez-vous vraiment réinitialiser le token Google Authenticator pour l'utilisateur ${user.firstName} ${user.lastName}?`}
          open={alertReset2FATokenOpen}
          onClose={closeAlertReset2FA}
          onAccept={handleReset2FA}
        />
      )}
      <UiButton
        variant="outlined"
        color="secondary"
        className={classNames({
          [classes.actionButtonModern]: isModern,
        })}
        onClick={(e: any) => actionButtonClicked(e)}
      >
        Actions
        <UiArrowIcon />
      </UiButton>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        disableAutoFocusItem
        onClose={closeMenu}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {options.map((option, index) => {
          if (option.roles.includes(userRole)) {
            return (
              <MenuItem
                key={option.label}
                onClick={(e: any) => onMenuClick(e, index)}
              >
                {option.label}
              </MenuItem>
            );
          } else {
            return null;
          }
        })}
      </Menu>
    </React.Fragment>
  );
};

export default withStyles(styles)(withRouter(withContext(UserActionButton)));
